import type { TimelineSchemaKind } from './models';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export function getTopLevelKeys(input: unknown): string[] {
  if (Array.isArray(input)) {
    const keys = new Set<string>(['[array]']);
    for (const item of input.slice(0, 50)) {
      if (!isRecord(item)) continue;
      for (const key of Object.keys(item)) keys.add(key);
    }
    return [...keys].sort((a, b) => a.localeCompare(b));
  }
  if (!isRecord(input)) return [];
  return Object.keys(input).sort((a, b) => a.localeCompare(b));
}

export function detectTimelineSchema(input: unknown): TimelineSchemaKind {
  if (Array.isArray(input)) {
    const sample = input.slice(0, 100).filter(isRecord);
    const looksLikeSemanticSegments = sample.some(
      (record) =>
        typeof record.startTime === 'string' &&
        typeof record.endTime === 'string' &&
        (isRecord(record.visit) || isRecord(record.activity) || Array.isArray(record.timelinePath)),
    );
    return looksLikeSemanticSegments ? 'new_device_timeline' : 'unknown';
  }

  if (!isRecord(input)) return 'unknown';

  if (Array.isArray(input.timelineObjects)) {
    return 'takeout_semantic_timeline';
  }

  if (Array.isArray(input.locations)) {
    return 'takeout_location_history';
  }

  if (Array.isArray(input.semanticSegments) || Array.isArray(input.rawSignals)) {
    return 'new_device_timeline';
  }

  return 'unknown';
}

export function describeSchemaKind(schema: TimelineSchemaKind): string {
  switch (schema) {
    case 'new_device_timeline':
      return '新しいデバイス内 Timeline 形式';
    case 'takeout_semantic_timeline':
      return 'Google Takeout Semantic Timeline 形式';
    case 'takeout_location_history':
      return 'Google Takeout Location History 形式';
    default:
      return '未対応または不明な JSON 形式';
  }
}
